export default {
  getScript: state => state.script,
  getScripts: state => state.scripts,
}
